// Geracao dinamica dos anos de veiculo.
// Fonte unica para as telas que precisam de um seletor de ano.

export const VEHICLE_YEAR_MIN = 1900;

// Retorna anos do ano atual ate VEHICLE_YEAR_MIN, em ordem decrescente.
export function getVehicleYearOptions() {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= VEHICLE_YEAR_MIN; year -= 1) years.push(String(year));
  return years;
}
